export default "__VITE_ASSET__DMopiKXq__"